module.exports = __webpack_public_path__ + "img/flag_en.67760e17.svg";